import { render } from "./HomeView.vue?vue&type=template&id=573799f0&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=573799f0&scoped=true&lang=css"

import exportComponent from "/home/lyramdc/Projects/face/ACE-face-name-test/v-face-memory/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573799f0"]])

export default __exports__